module.exports = __webpack_public_path__ + "static/media/team-hokyoung.2b0a75c3.jpg";